import { render, staticRenderFns } from "./NewsCard.vue?vue&type=template&id=2aa1ff36&scoped=true&"
import script from "./NewsCard.js?vue&type=script&lang=js&"
export * from "./NewsCard.js?vue&type=script&lang=js&"
import style0 from "./NewsCard.scss?vue&type=style&index=0&id=2aa1ff36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa1ff36",
  null
  
)

export default component.exports